import { type FC, useState, type ComponentProps } from "react";
import { Presentation } from "./Presentation";

type Props = Omit<ComponentProps<typeof Presentation>, "isShow" | "onClose" | "onClick">;

export const SectionDetailModal: FC<Props> = ({
  sectionName,
  sectionDescription,
  exampleAnswers,
  entryNote,
  entryUrl,
}) => {
  const [isShow, setIsShow] = useState(false);
  const handleOpenModal = () => setIsShow(true);
  const handleCloseModal = () => setIsShow(false);

  return (
    <Presentation
      isShow={isShow}
      onClick={handleOpenModal}
      onClose={handleCloseModal}
      sectionName={sectionName}
      sectionDescription={sectionDescription}
      exampleAnswers={exampleAnswers}
      entryNote={entryNote}
      entryUrl={entryUrl}
    />
  );
};
